import { RosaAuthService } from '@/rosa';
import { inject } from '@angular/core';
import { type CanActivateChildFn, type CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { SESSION_STORAGE_KEYS } from '../../providers/local-storage.contants';

export const passwordExpiredChangedGuard: CanActivateFn & CanActivateChildFn = async () => {
    const rosaAuthService = inject(RosaAuthService);
    const router = inject(Router);

    const isAuthenticatedWithSso = rosaAuthService.isAuthenticatedWithSso();
    const isPasswordExpired = await firstValueFrom(rosaAuthService.isPasswordExpired$());
    const isPrintingReport = sessionStorage.getItem(SESSION_STORAGE_KEYS.REPORT_PRINT_SESSION) === 'true';

    if (!isAuthenticatedWithSso && isPasswordExpired && !isPrintingReport) {
        router.navigate(['/', 'password-expired']);
        return false;
    }

    return true;
};
